import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 30000 }, // 30 seconds in milliseconds
  }

  declare intervalValue: number
  private refreshInterval: number | undefined

  connect() {
    // Start the refresh interval
    this.startRefreshing()
  }

  disconnect() {
    // Clean up the interval when the controller is disconnected
    this.stopRefreshing()
  }

  private startRefreshing() {
    this.refreshInterval = window.setInterval(() => {
      window.location.reload()
    }, this.intervalValue)
  }

  private stopRefreshing() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  }
} 